module.exports = __webpack_public_path__ + "img/add_user.86e5371c.svg";